/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';
import 'animate.css/animate.min.css';

import React from 'react';
import { Button } from 'react-bootstrap';

const defaultProps = {
  status: 'default',
};

const propTypes = {
  status: React.PropTypes.string,
  states: React.PropTypes.array.isRequired,
};


class RichButton extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      status: props.status,
      states: props.states,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { status, states } = nextProps;
    if (status !== this.props.status) {
      this.setState({ status });
    }
    if (states !== this.props.states) {
      this.setState({ states });
    }
  }

  render() {
    const { status, states } = this.state;
    let btnState = states.filter(s => s.status === status)[0];
    if (!btnState) {
      btnState = states.filter(s => s.status === 'default')[0];
    }

    const {
      style = 'primary',
      label,
      disabled,
      type,
      timer,
      delay = 3000,
    } = btnState;

    let { onClick = () => {} } = btnState;

    if (type === 'submit') {
      onClick = null;
    }


    if (timer) {
      setTimeout(timer, delay);
    }

    return (
      <Button
        bsStyle={`aisz-${style}`}
        onClick={onClick}
        disabled={disabled}
        type={type}
      >
        {label}
      </Button>
    );
  }
}

RichButton.defaultProps = defaultProps;
RichButton.propTypes = propTypes;


export default RichButton;





// WEBPACK FOOTER //
// ./src/components/RichButton/index.jsx